export { default } from './ChatBubbleLinesOutline'
